/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import {
    AlertsWidgetComponent,
    LicenceApiService,
    LicenceService,
    LicenseDetailsWidgetComponent,
    NetworkingApiService,
    PulsehaWidgetComponent,
    SystemMetricsWidgetComponent,
    SystemUpdatesWidgetComponent,
    VirtualServicesWidgetComponent
} from '../../shared';
import { BreadcrumbsComponent } from '../../../../core/components/breadcrumbs/breadcrumbs.component';
import { LoadbalancerSharedModule } from '../../shared/loadbalancer.shared.module';
import { NgChartsModule } from 'ng2-charts';
import { NgModule } from '@angular/core';
import { OverviewComponent } from './overview.component';
import { OverviewDetailsComponent } from './overview-details/overview-details.component';
import { RouterModule } from '@angular/router';

/**
 *
 */
@NgModule({
    imports: [
        BreadcrumbsComponent,
        LoadbalancerSharedModule,
        NgChartsModule,
        RouterModule
    ],
    declarations: [
        AlertsWidgetComponent,
        LicenseDetailsWidgetComponent,
        OverviewComponent,
        OverviewDetailsComponent,
        PulsehaWidgetComponent,
        SystemMetricsWidgetComponent,
        SystemUpdatesWidgetComponent,
        VirtualServicesWidgetComponent
    ],
    exports: [
        SystemMetricsWidgetComponent,
        VirtualServicesWidgetComponent
    ],
    providers: [
        LicenceApiService,
        LicenceService,
        NetworkingApiService
    ]
})

export class OverviewModule {
}
